import { createContext, useReducer } from "react";

export const FoodListContext = createContext();

export const foodListReducer = (state, action) => {
    switch (action.type) {
        case 'SET_FOOD_LIST':
            return {
                foodList: action.payload
            }
        case 'CREATE_FOOD_LIST':
            return {
                foodList: [action.payload, ...state.foodList]
            }
        case 'DELETE_FOOD_LIST':
            return {
                foodList: state.foodList.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const FoodListContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(foodListReducer, {
        foodList: null
    });

    return (
        <FoodListContext.Provider value={{ ...state, dispatch }}>
            {children}
        </FoodListContext.Provider>
    );
};